<template>
    <div class="disable-payment-popup">
        <div class="disable-payment-popup__inner">
            <div class="disable-payment-popup__container">
                <div class="disable-payment-popup__title">
                    <div class="disable-payment-popup__close-btn" @click="closeDisablePaymentPopup"></div>
                </div>
                <div class="disable-payment-popup__text" v-html="stubText"></div>
            </div>
        </div>
        <popup-overlay :on="true" @closePopup="closeDisablePaymentPopup" />
    </div>
</template>

<script>
import PopupOverlay from './PopupOverlay.vue';
export default {

    name: 'DisablePaymentPopup',
    components: {
        PopupOverlay
    },
    props: {
        stubText: {
            type: String,
            default: '<div>Оплата временно недоступна</div>'
        },
    },
    methods: {
        closeDisablePaymentPopup() {
            this.$emit('popup-opened', false)
        }
    }

};
</script>

<style lang="scss" scoped>
    @import '../assets/scss/mixins-and-vars';
    .disable-payment-popup {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        color: #333;
        font-family: 'HelveticaNeueCyr', 'Helvetica Neue', Arial, sans-serif;
        z-index: 1000;
        &__inner {
            display: flex;
            flex-direction: column;
            position: absolute;
            max-width: 600px;
            max-height: calc(100% - 30px);
            width: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding: 28px;
            background: #fff;
            border-radius: 20px;
            z-index: 3;
            animation: easeOpen 0.15s ease-in-out;
            overflow: auto;
            overscroll-behavior: none;

            @include mobile {
                width: calc(100% - 30px);
                transform: translate(calc(-50% - 10px), -50%);
                padding: 10px;
                margin: 0 10px;
            }
        }
        &__container {
            display: flex;
            flex-direction: column;
            padding: 20px;
            overflow: auto;
        }
        &__title {
            position: relative;
            font-weight: 700;
            font-size: 24px;
            line-height: 24px;
            margin-right: 25px;

            @include mobile {
                font-size: 22px;
            }
        }
        &__close-btn {
            position: absolute;
            right: -21px;
            top: 50%;
            transform: translateY(-50%);
            height: 19px;
            width: 19px;
            cursor: pointer;
            background: #fff;

            &::before,
            &::after {
                position: absolute;
                display: block;
                content: '';
                top: 50%;
                left: 50%;
                width: 26px;
                height: 1px;
                background: #6c6c6c;
            }

            &::after {
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::before {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        &__text {
            margin-top: 10px;
            line-height: 1.5;
            >* {
                margin-top: 10px;
            }
        }
    }
</style>

<style>
    .addMarginTop {
        margin-top: 15px;
    }

    .lb_message {
        font-size: 39px;
        color: #00abaa;
        margin-top: 30px;
        margin-bottom: 1em;
        line-height: 1.2;
        font-weight: bold;
    }
</style>